import * as React from 'react';

import { EtazhiBlackFridayPromoOffers } from '../EtazhiBlackFridayPromoOffers';
import { EtazhiBlackFridayTopBanner } from '../EtazhiBlackFridayTopBanner';
import { useGetPromoOffers, usePromoOffersVisibility } from './hooks';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export const EtazhiBlackFridayPromotion: React.FC = () => {
  const isPromoOffersVisible = usePromoOffersVisibility();

  const { isFetched, hasData } = useGetPromoOffers(isPromoOffersVisible);

  /**
   * "Полка" видна, но данные ещё не загружены - не показываем "полку".
   */
  if (isPromoOffersVisible && !isFetched) {
    return null;
  }

  /**
   * "Полка" видна, данные загружены и не пустые - показываем полку.
   */
  if (isPromoOffersVisible && isFetched && hasData) {
    return <EtazhiBlackFridayPromoOffers />;
  }

  return <EtazhiBlackFridayTopBanner isButtonVisible={isPromoOffersVisible} />;
};
